// FilterData interface
export interface FilterData {
  id: number
  value: string
  label: string
  enabled: boolean
}

// Disabled options on base filter selection
export interface DisabledOptions {
  baseValue: string
  disabled: string[]
}

// State definition
export const states: Array<FilterData> = [
  {
    id: 0,
    value: 'National',
    label: 'National',
    enabled: true,
  },
  {
    id: 1,
    value: 'NSW',
    label: 'New South Wales',
    enabled: true,
  },
  {
    id: 2,
    value: 'QLD',
    label: 'Queensland',
    enabled: true,
  },
  {
    id: 3,
    value: 'SA',
    label: 'South Australia',
    enabled: true,
  },
  {
    id: 4,
    value: 'VIC',
    label: 'Victoria',
    enabled: true,
  },
  {
    id: 5,
    value: 'WA',
    label: 'Western Australia',
    enabled: true,
  },
].filter((state) => state.enabled)

// Region definition
export const regions: Array<FilterData> = [
  {
    id: 0,
    value: 'All',
    label: 'All',
    enabled: true,
  },
  {
    id: 1,
    value: 'Metro',
    label: 'Greater capital city',
    enabled: true,
  },
  {
    id: 2,
    value: 'Regional',
    label: 'Rest of state',
    enabled: true,
  },
].filter((region) => region.enabled)

// Index type definition
export const indextypes: Array<FilterData> = [
  {
    id: 0,
    value: 'base',
    label: 'Base',
    enabled: true,
  },
  {
    id: 1,
    value: 'de-seasonalized-smoothed',
    label: 'Seasonally adjusted',
    enabled: true,
  },
].filter((indextype) => indextype.enabled)

// Index detaitype definition
export const indexdetails: Array<FilterData> = [
  {
    id: 0,
    value: 'VOLUME',
    label: 'VOLUME',
    enabled: true,
  },
  {
    id: 1,
    value: 'VALUE',
    label: 'VALUE',
    enabled: false,
  },
].filter((indexdetail) => indexdetail.enabled)

// Disable the state options in 'disabled' if the baseValue is a selected filter
export const stateDisabledOptions: Array<DisabledOptions> = [
  {
    baseValue: 'Metro',
    disabled: ['QLD', 'National'],
  },
  {
    baseValue: 'Regional',
    disabled: ['QLD', 'National'],
  },
]

// Disable the region options in 'disabled' if the baseValue is a selected filter
export const regionDisabledOptions: Array<DisabledOptions> = [
  {
    baseValue: 'QLD',
    disabled: ['Metro', 'Regional'],
  },
  {
    baseValue: 'National',
    disabled: ['Metro', 'Regional'],
  },
]

export enum GROUP_TYPE {
  STATE = 'state',
  INDEX_TYPE = 'index_type',
  REGION = 'region',
}
